module.exports = __webpack_public_path__ + "img/1.56c5d4f9.png";